import { render } from "./project-detail.vue?vue&type=template&id=7c4b2e84"
import script from "./project-detail.vue?vue&type=script&lang=js"
export * from "./project-detail.vue?vue&type=script&lang=js"

import "./project-detail.vue?vue&type=style&index=0&id=7c4b2e84&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__